export enum PermissionGroups {
    Admin = "LRNext-Admin",
    BillingAdmin = "LRNext-Billing-Admin",
    AccountsPayableAdmin = "LRNext-AccountsPayable-Admin",
    AccountsPayableContributor = "LRNext-AccountsPayable-Contributor",
    BillingContributor = "LRNext-Billing-Contributor",
    MemberServicesAdmin = "LRNext-MemberServices-Admin",
    MemberServicesContributor = "LRNext-MemberServices-Contributor",
    MarketingContributor = "LRNext-Marketing-Contributor",
    AccountsReceivableAdmin = "LRNext-AccountsReceivable-Admin",
    ClientServicesContributor = "LRNext-ClientServices-Contributor",
    ClientServicesAdmin = "LRNext-ClientServices-Admin",
    EDIContributor = "LRNext-EDI-Contributor",
    ImplementationAdmin = "LRNext-Implementation-Admin",
    AttorneyRelationsContributor = "LRNext-AttorneyRelations-Contributor",
    AttorneyRelationsAdmin = "LRNext-AttorneyRelations-Admin",
}
